// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"20f48403","103":"b31f23a6","136":"c7a92a5e","153":"d50303b2","453":"ba36cf83","457":"26399467","559":"cef5e092","687":"9d8c976f"}[chunkId] + ".chunk.js";
};